import {
  ConversationStatisticRequest,
  ConversationStatisticResponse,
  MostUsedDocumentsRequest,
  MostUsedDocumentsResponse,
  UserStatisticResponse,
} from "@/models/statistic/Statistic";
import RequestMethod from "../models/client/RequestMethod";
import RestResponse from "../models/client/RestResponse";
import { RestClient } from "./restClient";

export type StatisticServiceType = {
  getTenantStatistics: (
    request: ConversationStatisticRequest
  ) => RestResponse<ConversationStatisticResponse>;
  getUsersStatistics: (
    request: ConversationStatisticRequest
  ) => RestResponse<UserStatisticResponse>;
  getMostUsedDocuments: (
    request: MostUsedDocumentsRequest
  ) => RestResponse<MostUsedDocumentsResponse>;
};

const statisticServices = (
  client: RestClient,
  path: string
): StatisticServiceType => ({
  getTenantStatistics: async (request) =>
    await client.fetch<ConversationStatisticResponse>(
      RequestMethod.GET,
      `${path}?StartDate=${request.startDate}&EndDate=${request.endDate}&ComparedStartDate=${request.comparedStartDate}&ComparedEndDate=${request.comparedEndDate}`
    ),
  getUsersStatistics: async (request) =>
    await client.fetch<UserStatisticResponse>(
      RequestMethod.GET,
      `${path}/users-statistics?StartDate=${request.startDate}&EndDate=${request.endDate}&ComparedStartDate=${request.comparedStartDate}&ComparedEndDate=${request.comparedEndDate}`
    ),
  getMostUsedDocuments: async (request) =>
    await client.fetch<MostUsedDocumentsResponse>(
      RequestMethod.GET,
      `${path}/documents/most-used?TotalCount=${request.totalCount}&SortDirection=${request.sortDirection}&DocumentSourceTypes=${request.type}`
    ),
});

export default statisticServices;
